import { resolveComponent as _resolveComponent, createVNode as _createVNode, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_input = _resolveComponent("q-input")!

  return (_openBlock(), _createBlock(_component_q_input, _mergeProps({
    type: _ctx.isVisible ? 'text' : 'password',
    name: "password",
    "model-value": _ctx.modelValue
  }, _ctx.$attrs, {
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:modelValue', $event)))
  }), {
    append: _withCtx(() => [
      _createVNode(_component_q_btn, {
        label: _ctx.isVisible ? 'Hide' : 'View',
        title: _ctx.isVisible ? 'Hide Password' : 'View Password',
        "no-caps": "",
        flat: "",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isVisible = !_ctx.isVisible))
      }, null, 8, ["label", "title"])
    ]),
    _: 1
  }, 16, ["type", "model-value"]))
}